import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Skill } from "@cohesive/api-client";

interface DeleteSkillDialogProps {
  skill: Skill | null;
  onConfirmDelete: (skill: Skill) => Promise<void>;
  onCancel: () => void;
}

export const DeleteSkillDialog: React.FC<DeleteSkillDialogProps> = ({
  skill,
  onConfirmDelete,
  onCancel,
}) => {
  return (
    <Dialog open={!!skill} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Archive this skill?</DialogTitle>
          <DialogDescription>
            "{skill?.name}" will be archived. You can restore it any time.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={async () => {
              if (skill) {
                await onConfirmDelete(skill);
                window.setTimeout(() => onCancel(), 0);
              }
            }}
          >
            Archive
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
